import { useContext, useEffect } from 'react'
import { RequestContext } from '../context/RequestContext'

// Append the date/time step's price summary (serviceSummary) to the request
// remarks when the submit step shows.
//
// Going Back and returning mounts the submit step again, possibly with a new
// summary (another time slot), so the summary appended last time is swapped
// out instead of adding a second one. appendedSummaryRef must outlive the
// submit step: the form container owns it (a useRef there).
export const useServiceSummaryAppend = (appendedSummaryRef) => {
    const { serviceSummary, setRequestDescription } = useContext(RequestContext)

    useEffect(() => {
        if (!serviceSummary) return
        const previous = appendedSummaryRef?.current
        if (appendedSummaryRef) appendedSummaryRef.current = serviceSummary
        setRequestDescription(requestDescription => {
            let base = requestDescription || ""
            if (previous && base.endsWith(previous)) {
                base = base.slice(0, base.length - previous.length).replace(/ - $/, "")
            }
            if (base.endsWith(serviceSummary)) return base
            return base ? base + " - " + serviceSummary : serviceSummary
        })
    }, [serviceSummary, setRequestDescription, appendedSummaryRef])
}
